import { isEqual } from 'lodash';
import { navigateTo } from '@cat-ecom/common/utils/browserUtils';
import { selectEquipment } from 'services/equipment/actions';
import { getSeoUrl } from 'utils/links';

import { ALP_URL } from 'constants/links';
import { Params } from 'next/dist/shared/lib/router/utils/route-matcher';

import { HEADLESS_ALP_PAGE } from 'constants/links';

export const redirectFromEquipment = async (
  url: string,
  isSelectedEquipment: boolean,
  equipmentDetails: {
    id: string;
    serialNumber: string;
  }
) => {
  const response =
    !isSelectedEquipment &&
    (await selectEquipment(
      equipmentDetails?.id,
      equipmentDetails?.serialNumber,
      false
    ));

  if (isSelectedEquipment || response.ok) {
    navigateTo(url);
  }
};

export const isExistingSuggestion = (data, suggestions) => {
  return (
    isEqual(
      suggestions?.equipments,
      data?.equipments || data?.matchedEquipment || data?.equipment
    ) &&
    isEqual(
      suggestions?.otherEquipments,
      data?.otherEquipments || data?.partiallyMatchedEquipment
    )
  );
};

export const checkIsAlpPage = (params, path: string) => {
  const { ['part-number']: partNumber, ['part-name']: partName } = params;
  const esitURL = getSeoUrl(params, HEADLESS_ALP_PAGE);
  const alpURL = `${esitURL}/${partName}/${partNumber}`;
  return alpURL === path;
};

export const handleSuggestionResults = (data) => {
  let suggestions = null;
  if ('equipments' in data) {
    suggestions = {
      equipments: data.equipments ?? [],
      otherEquipments: data.otherEquipments ?? []
    };
  } else if ('matchedEquipment' in data) {
    suggestions = {
      equipments: data.matchedEquipment ?? [],
      otherEquipments: data.partiallyMatchedEquipment ?? []
    };
  } else if ('equipment' in data) {
    suggestions = {
      equipments: data.equipment ?? []
    };
  }
  return suggestions;
};

export const getFormattedSeoUrl = (seoUrl: string, params: Params) => {
  const { esite, lang } = params;
  return seoUrl.replace(`/${lang}/${esite}`, '');
};

export const redirectToNewAlpUrl = async (
  router,
  featureFlag: boolean,
  params: Params,
  seoUrl: string,
  isSelectedEquipment = true,
  equipmentDetails?: {
    id: string;
    serialNumber: string;
  }
) => {
  const response =
    !isSelectedEquipment &&
    (await selectEquipment(
      equipmentDetails?.id,
      equipmentDetails?.serialNumber,
      false
    ));
  const formattedSeoUrl = getFormattedSeoUrl(seoUrl, params);
  const alpUrl = featureFlag ? `${ALP_URL}${formattedSeoUrl}` : formattedSeoUrl;
  const url = getSeoUrl(params, alpUrl);
  if (isSelectedEquipment || response.ok) {
    if (featureFlag) {
      router.push(url);
    } else {
      navigateTo(url);
    }
  } else {
    router.push(url);
  }
};
